import React from 'react';
import { Button } from '@/shared/ui/Button';
import { ExtBadge, PNBadge } from './CampaignBadges';
import { formatConversions } from '@/shared/utils/format';
import styles from './ExistingCampaignRow.module.css';

export interface ExistingCampaign {
  id: string;
  name: string;
  spend: number;
  conversions: number;
  dailyBudget: number | null;
  source: 'pn-ai' | 'external';
}

interface Props {
  campaign: ExistingCampaign;
  kept: boolean;
  onKeep: () => void;
  onPause: () => void;
}

export function ExistingCampaignRow({ campaign, kept, onKeep, onPause }: Props) {
  const c = campaign;
  return (
    <div className={styles.row}>
      <div className={styles.label}>
        {c.source === 'pn-ai' ? <PNBadge /> : <ExtBadge />}
        <div>
          <div className={styles.name}>{c.name}</div>
          <div className={styles.meta}>
            {c.dailyBudget ? `$${Math.round(c.dailyBudget * 30).toLocaleString()}/mo` : '—'} · $
            {c.spend.toFixed(0)} spent · {formatConversions(c.conversions)} conv.
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <Button variant={kept ? 'primary' : 'tertiary'} size="sm" onClick={onKeep}>
          Keep
        </Button>
        <Button variant={!kept ? 'primary' : 'tertiary'} size="sm" onClick={onPause}>
          Pause
        </Button>
      </div>
    </div>
  );
}
